import { render } from "./dialogForm.vue?vue&type=template&id=d67d28d0&scoped=true"
import script from "./dialogForm.vue?vue&type=script&lang=js"
export * from "./dialogForm.vue?vue&type=script&lang=js"

import "./dialogForm.vue?vue&type=style&index=0&id=d67d28d0&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d67d28d0"]])

export default __exports__